import React from 'react';
import { withTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import {
    Box,
    Card,
    DatePicker,
    InternalGrid,
    Text,
    DaButton,
    ScheduleIcon,
    MeterIcon,
} from '@paygreen/paygreen-ui';
import dayjs from '../../../utils/dayjsHelper';
import { startOfMonth, endOfMonth } from '../../../utils/constants';
import { IsMobile } from '../../../utils/tools';
import { useUser } from '../../../context';

const FilterTable = ({ t, setEndDate, setStartDate, endDate, startDate }) => {
    const { user } = useUser();

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const searchEndDate = searchParams.get('endDate');
    const searchStartDate = searchParams.get('startDate');

    // we apply as the minimum startDate the first day of the month of subscription of the user
    const minimumStartDate =
        user.createdAt &&
        dayjs(new Date(user.createdAt * 1000)).format('01/MM/YYYY');

    return (
        <Card
            colorWab="white10"
            shadowSize="none"
            paddingLateral="xs"
            paddingTop="xs"
            radiusSize="sm"
            blockWidth="xl"
        >
            <InternalGrid
                alignItems="center"
                justifyContent="flex-start"
                hasStaticWidth={false}
                childrenMarginBottom={IsMobile() ? 'sm' : 'md'}
            >
                <InternalGrid
                    displayType="grid"
                    gridTemplateColumns="auto auto "
                    gridGap="md"
                    alignItems="center"
                >
                    <Text textSize="xs">{t('datePicker.from')}</Text>

                    <Box marginRight="sm">
                        <DatePicker
                            locale={t('datePicker.locale')}
                            id="startDate"
                            minimumDate={minimumStartDate}
                            maximumDate={endDate || endOfMonth}
                            fieldSize="sm"
                            blockWidth="sm"
                            resetDate={endDate}
                            value={startDate || startOfMonth}
                            onChange={(date) => setStartDate(date)}
                            icon={<ScheduleIcon />}
                        />
                    </Box>
                </InternalGrid>

                <InternalGrid
                    displayType="grid"
                    gridTemplateColumns="auto auto"
                    gridGap="md"
                    alignItems="center"
                >
                    <Text textSize="xs">{t('datePicker.to')}</Text>

                    <Box marginRight="sm">
                        <DatePicker
                            locale={t('datePicker.locale')}
                            id="endDate"
                            minimumDate={startDate || startOfMonth}
                            maximumDate={endOfMonth}
                            fieldSize="sm"
                            blockWidth="sm"
                            resetDate={startDate}
                            value={endDate || endOfMonth}
                            onChange={(date) => setEndDate(date)}
                            icon={<ScheduleIcon />}
                        />
                    </Box>
                </InternalGrid>

                {!IsMobile() && (searchEndDate || searchStartDate) ? (
                    <Link to={`/?${searchParams.toString()}`}>
                        <DaButton
                            buttonSize="sm"
                            buttonStyle="line"
                            gradient="theme"
                            icon={<MeterIcon />}
                        >
                            {t('filter.dashboard.link')}
                        </DaButton>
                    </Link>
                ) : null}
            </InternalGrid>
        </Card>
    );
};

export default withTranslation('common')(FilterTable);
